import { Icon } from 'components/Icon/Icon';
import { BodySmall } from 'components/Text/BodySmall';

import { DropBox } from './DropBox';

type Props = {
  id?: string;
  buttonOnly?: boolean;
  previewWidth?: number;
  previewHeight?: number;
  message?: string;
};

export function ImagePickerButton({
  id,
  buttonOnly,
  previewWidth,
  previewHeight,
  message,
}: Props) {
  return (
    <div style={{ margin: `${buttonOnly ? 0 : 22}px -10px` }}>
      <DropBox id={id} position="relative" borderRadius="8px" p={10}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 16px',
            flexDirection: buttonOnly ? 'column' : undefined,
            width: buttonOnly ? previewWidth : undefined,
            height: buttonOnly ? previewHeight : undefined,
            justifyContent: buttonOnly ? 'center' : undefined,
            textAlign: buttonOnly ? 'center' : undefined,
          }}
        >
          <div>
            <Icon name="upload" size={23} />
          </div>

          <BodySmall
            my={0}
            ml={buttonOnly ? undefined : '8px'}
            mt={buttonOnly ? '8px' : undefined}
            lineHeight={1.375}
          >
            {message}
          </BodySmall>
        </div>
      </DropBox>
    </div>
  );
}
